import React from "react";
import { FaRegCircleXmark } from "react-icons/fa6";

import "./styles.scss"

const UnSubscribeUI = () => {
    return (
        <div className="unsubscribed-container">
            <div className="icon"><FaRegCircleXmark /></div>
            <div className="message">You have not yet subscribed to this feature!</div>
        </div>
    )
}

export default UnSubscribeUI